var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-circle"},[_c('canvas',{staticClass:"canvas-view",attrs:{"id":_vm.canvasId}})])}
var staticRenderFns = []

export { render, staticRenderFns }